export default __webpack_public_path__ + "static/media/Yellow_Player_Podium_min.e6504b82.png";